import MetricChart from "./MetricChart";
import { endpoints } from "../../helpers/Endpoints";

export default function UserMetrics() {
  return (
    <MetricChart
      title="User Metrics"
      endpoint={endpoints.getUserMetrics}
      queryParamKey="user_type"
      datasetMap={{
        all: 'ALL',
        customer: 'CUSTOMER',
        student: 'STUDENT'
      }}
    />
  );
}
